<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="origineSvc.getHelp()"
               [width]="800"></yo-help>
      <span class="mg-r-15">
        <yo-button
          label="CRÉER"
          iconClass="fa fa-plus"
          (onClick)="createOrigine()">
        </yo-button>
    </span>
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="origineList"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(100)"
  [width]="'100%'"
  columnResizingMode="widget"
  [cacheEnabled]="false"
  [remoteOperations]="true"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="id" alignment="center" caption="Actions"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="site.libelle" alignment="center" caption="Site"
              [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="siteCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" alignment="center" caption="Libelle"
              [allowFiltering]="true" [filterOperations]="['contains']">
  </dxi-column>
  <dxi-column dataField="code" alignment="center" caption="Code"
              [allowFiltering]="true" [filterOperations]="['contains']">
  </dxi-column>
  <dxi-column dataField="actif" alignment="center" caption="Actif"
              [allowFiltering]="false">
  </dxi-column>


  <div *dxTemplate="let cell of 'siteCellTemplate'">
    <yo-site [siteLibelle]="cell.data.site.libelle"
             [siteId]="cell.data.site.id">
    </yo-site>
  </div>

  <dxo-selection
    [selectAllMode]="'allPages'"
    [showCheckBoxesMode]="'onClick'"
    mode="single">
  </dxo-selection>
  <dxo-paging [pageSize]="50"></dxo-paging>
  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[20, 50, 100]"
    [showNavigationButtons]="true"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} Origines">
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <!--    TEMPLATE-->
  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-cell-button (yoNavigation)="openEditObject(cell.row.data)"
                    [yoTooltipShowDelay]="1500"
                    [yoSmall]="true"
                    yoTextAlign="center"
                    [yoIconClass]="auth2Svc.isSiteLocal(cell.row.data.site.id)?'fa fa-edit':'fas fa-eye'"
                    [yoTooltip]="auth2Svc.isSiteLocal(cell.row.data.site.id)?'Modifier l\'origine':'Voir l\'origine'"
    ></yo-cell-button>

    <yo-cell-button (yoNavigation)="openDeleteObject(cell.row.data)"
                    [yoTooltipShowDelay]="1500"
                    [yoSmall]="true"
                    [yoDisabled]="!auth2Svc.isSiteLocal(cell.row.data.site.id)"
                    yoTextAlign="center"
                    yoIconClass="fa fa-trash"
                    [yoTooltip]="!auth2Svc.isSiteLocal(cell.row.data.site.id)? 'Vous n\'avez pas les droits pour supprimer cette origine' :'Supprimer l\'origine'"
    ></yo-cell-button>
  </div>
</dx-data-grid>

<!--DIALOG EDITION ORIGINE-->
<yo-dialog-origine></yo-dialog-origine>
